<template>
  <div :class="['home', fullpageClass]">
    <!-- Register, uses Fullpage -->
    <div :class="['register-container', showRegisterClass]">
      <div id="register-form"></div>
    </div>

    <!-- Homepage -->
    <div :class="['center', showHomepageClass]">
      <div class="padded-width">
        <button
          @click="showTheForm"
          :class="['button', 'buttony', 'fit', showButtonClass]"
        >
          <span>✦</span>&nbsp;&nbsp;Stay Updated&nbsp;&nbsp;<span>✦</span>
        </button>
        <div :class="['message', showSuccessClass]">
          <p class="label submitted-label">Submitted</p>
          <p :class="['note', hideIfATMClass]">Bring your USB.</p>
          <p :class="['note', 'for-atm', atATMClass]">
            Plug-in your USB to begin.
          </p>
          <div :class="[hideIfNotAtmClass, 'callout']">
            <p class="note">Your ATM PIN is</p>
            <p class="code label">
              {{ transferCode }}
            </p>
          </div>
        </div>
        <div :class="['message', showErrorClass]">
          <p class="label">Uh Oh</p>
          <p class="note">There was an error,<br />please try again.</p>
        </div>
        <form
          id="phoneForm"
          name="phones"
          @submit="process"
          :class="['formy', showFormClass]"
        >
          <p :class="['for-atm', atATMClass]">Register for your ATM PIN</p>
          <input type="hidden" name="form-name" value="phones" />
          <input
            id="name"
            type="text"
            name="name"
            class="phone-input name-input"
            placeholder="Name"
          />
          <input
            id="email"
            type="email"
            name="email"
            placeholder="Email"
            class="phone-input email-input"
          />
          <input id="phone" type="tel" name="phone" class="phone-input" />
          <br />
          <button type="submit" class="button">Submit</button>
        </form>
        <div class="alert alert-info" style="display: none"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { createWidget } from "@typeform/embed";
import "@typeform/embed/build/css/widget.css";

export default {
  name: "Home",
  components: {},
  data() {
    return {
      showThanks: false,
      showCareering: false,
      showSignup: true,
      phoneInputField: null,
      phoneInput: null,
      showForm: false,
      showSuccess: false,
      showError: false,
      showRegister: false,
      transferCode: "**-**-**",
      atATM: false,
    };
  },
  computed: {
    atATMClass() {
      return this.atATM == true ? "atm-show" : "";
    },
    hideIfATMClass() {
      return this.atATM == true ? "atm-hide" : "";
    },
    hideIfNotAtmClass() {
      return this.atATM == true ? "" : "non-atm-hide";
    },
    showButtonClass() {
      return this.showForm == true || this.showSuccess == true
        ? "hide-button"
        : "";
    },
    showHomepageClass() {
      return this.showCareering == true || this.showRegister == true
        ? "hide-homepage"
        : "";
    },
    fullpageClass() {
      return this.showRegister == true ? "fullpage" : "";
    },
    showRegisterClass() {
      return this.showRegister == true ? "show-register" : "";
    },
    showCareeringClass() {
      console.log(this.showCareering, "show careering?");
      return this.showCareering == true ? "show-careering" : "";
    },
    showFormClass() {
      return this.showForm == true ? "show-form" : "";
    },
    showSuccessClass() {
      return this.showSuccess == true ? "show-success" : "";
    },
    showErrorClass() {
      return this.showError == true ? "show-error" : "";
    },
  },
  created() {
    if (window.location.href.includes("#thanks")) {
      this.formSuccess();
    }

    if (window.location.pathname == "/y") {
      window.location.replace("https://twitter.com/usbclub");
    }

    if (window.location.pathname == "/register") {
      this.setupRegister();
    }

    if (window.location.pathname == "/about") {
      this.goToCareering();
    }
  },
  mounted() {
    this.transferCode = this.generateTransferCode();

    if (window.location.pathname == "/register") {
      this.goToRegister();
    }

    if (window.location.pathname == "/atm") {
      this.setupForAtm();
    }

    // let testIP = this.getIp((result) => {
    //   console.log("ip result: ", result);
    // });
    this.phoneInputField = document.querySelector("#phone");
    this.phoneInput = window.intlTelInput(this.phoneInputField, {
      preferredCountries: ["us", "mx", "jp", "fr", "gb"],
      initialCountry: "auto",
      geoIpLookup: this.getIp,
      utilsScript:
        "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
    });
  },
  methods: {
    setupForAtm() {
      this.atATM = true;
      this.showTheForm();

      // this.showSuccessMessage(); // for testing only
    },
    setupRegister() {
      this.showRegister = true;
    },
    goToRegister() {
      this.createTypeform();
    },
    createTypeform() {
      createWidget("nytSxyoZ", {
        container: document.querySelector("#register-form"), // you need an element with 'form' id
        hideHeaders: true,
        hideFooter: true,
        opacity: 0,
      });
    },
    goToCareering() {
      this.showCareering = true;
      // this.setupLoom();
    },
    formSuccess() {
      this.showThanks = true;
      this.showSignup = false;
    },
    showTheForm() {
      this.showForm = true;
    },
    process(event) {
      event.preventDefault();
      let phoneForm = document.getElementById("phoneForm");
      let formData = new FormData(phoneForm);
      let phoneNumber = this.phoneInput.getNumber();
      formData.set("phone", phoneNumber);
      formData.set("atATM", this.atATM);
      let transferCode = this.atATM === true ? this.transferCode : "";
      formData.set("transferCode", transferCode);

      fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(formData).toString(),
      })
        .then(() => {
          console.log("Form successfully submitted");
          this.showSuccessMessage();
        })
        .catch((error) => {
          console.log(error);
          this.showErrorMessage();
        });
    },
    showSuccessMessage() {
      this.showForm = false;
      this.showSuccess = true;
    },
    showErrorMessage() {
      this.showForm = false;
      this.showError = true;
    },
    getIp(callback) {
      fetch("https://ipinfo.io/json?token=712a2dd750ab01", {
        headers: { Accept: "application/json" },
      })
        .then((resp) => resp.json())
        .catch(() => {
          return {
            country: "us",
          };
        })
        .then((resp) => callback(resp.country));
    },
    generateTransferCode() {
      var code = "";
      for (var i = 0; i < 3; i++) {
        // Generate two random digits
        var num1 = Math.floor(Math.random() * 10);
        var num2 = Math.floor(Math.random() * 10);

        // Add them to the code, followed by a dash if it's not the last pair
        code += num1.toString() + num2.toString();
        if (i < 2) code += "-";
      }
      return code;
    },
  },
};
</script>

<style scoped>
.home {
  height: 100%;
  width: 100%;
}

.content-container {
  width: 100%;
}

.phone-input {
  background: #EBEBEB;
  -webkit-appearance: none;
  box-shadow: inset 0px -5px 3px rgb(255 255 255 / 85%),
    inset 0px 4px 5px rgb(0 0 0 / 26%);
  border-radius: 8px;
  font-size: 16px;
  font-family: "Good", sans-serif;
  line-height: 150%;
  padding-top: 8px;
  padding-bottom: 8px;
  border: none;
}

.name-input {
  width: 100%;
  box-sizing: border-box;
  padding-left: 9px;
  margin-bottom: 12px;
}

.email-input {
  width: 100%;
  box-sizing: border-box;
  padding-left: 9px;
  margin-bottom: 12px;
}

.iti__country-list {
  color: black;
  font-family: "Good", sans-serif;
}

.buttony {
  position: relative;
  opacity: 1;
  transition: all 300ms ease-in-out;
}

.buttony.hide-button {
  pointer-events: none;
  opacity: 0;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  user-select: none;
}

.center.hide-homepage {
  opacity: 0;
  display: none;
}

.formy {
  position: absolute;
  opacity: 0;
  pointer-events: none;
  transition: all 300ms ease-in-out;
  transition-delay: 100ms;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  user-select: none;
}

.formy.show-form {
  opacity: 1;
  pointer-events: all;
  -webkit-touch-callout: text; /* iOS Safari */
  -webkit-user-select: text; /* Safari */
  user-select: text;
}

.message {
  position: absolute;
  opacity: 0;
  pointer-events: none;
  transition: all 300ms ease-in-out;
  transition-delay: 150ms;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  user-select: none;
}

.message.show-success {
  opacity: 1;
  pointer-events: all;
  -webkit-touch-callout: text; /* iOS Safari */
  -webkit-user-select: text; /* Safari */
  user-select: text;
}

.message.show-error {
  opacity: 1;
  pointer-events: all;
  -webkit-touch-callout: text; /* iOS Safari */
  -webkit-user-select: text; /* Safari */
  user-select: text;
}

.message .label {
  font-family: "ISO", monospace;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  font-size: 14px;
  line-height: 150%;
  margin-bottom: 4px;
}

.message .note {
  font-family: "Good", sans-serif;
  font-size: 18px;
  line-height: 150%;
  margin-top: 0;
}

.one-pager {
  text-align: center;
  height: 100%;
  display: grid;
  grid-template-rows: 1fr 120px;
}

.one-pager.fullpage {
  grid-template-rows: 1fr;
}

.one-pager.fullpage .by {
  display: none;
}

.center {
  height: 100%;
  max-height: 100%;
  width: 100%;
  /* padding-top: 60px; */

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.register-container {
  display: none;
}

.register-container.show-register {
  display: flex;
  flex-direction: column;
}

.register-container,
#register-form {
  width: 100%;
  height: 100%;
}

.callout {
  background: linear-gradient(180deg, #252525 0%, #151515 100%);
  border: 1px solid rgb(27 27 27);
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.4);
  border-radius: 5px;
  padding: 20px;
  margin-top: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 240px;
}

.callout .code {
  font-size: 24px;
  line-height: 150%;
  padding: 0;
  margin: 0;
}

.callout .note {
  font-size: 16px;
  color: #D8D8D8;
  margin-bottom: 8px;
}

.submitted-label {
  margin-top: 0;
}

.for-atm {
  display: none;
  text-align: center;
  margin-bottom: 1.6rem;
  font-size: 1.8rem;
  line-height: 150%;
  font-weight: 400;
  font-family: "Untitled Sans", sans-serif;
}

.for-atm.atm-show {
  display: block;
}

.atm-hide {
  display: none;
}

.non-atm-hide {
  display: none;
}

.about-section {
  text-align: left;
  margin-top: 80px;
}

.about-section .label {
  color: #DDEDFF;
  font-size: 16px;
  font-family: "ISO", monospace;
  text-transform: uppercase;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: 1.5px;
  margin-bottom: 12px;
}

.features {
  display: flex;
  flex-direction: row;
  grid-gap: 16px;
  margin-bottom: 16px;
}

.feature {
  display: flex;
  flex-direction: row;
  align-items: center;
  grid-gap: 8px;
}

.feature-icon {
  display: flex;
}

.feature-label {
  color: #FFF;
  font-size: 16px;
  font-family: "Good", sans-serif;
  font-weight: 450;
  line-height: 150%;
}

h2 {
  color: #FFF;
  font-size: 40px;
  font-family: "Rowdies";
  line-height: 120%;
  margin-top: 0;
  margin-bottom: 24px;
}

p {
  color: #CFCFCF;
  font-size: 21px;
  font-family: "Good", sans-serif;
  font-weight: 450;
  line-height: 150%;
}

p.faded {
  color: #999999;
}

p.faded a {
  color: #999999;
}

p.faded a:hover {
  color: #fff;
}

.team-item {
  border-bottom: 1px solid #5F5F5F;
  margin-bottom: 24px;
  padding-bottom: 24px;
}

.team-item p {
  margin: 0;
  padding: 0;
}

.team-item:last-child {
  border-bottom: none;
}

.about-section .image-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.about-section img {
  max-width: 260px;
}
</style>
